import { render } from "./assign-trustcontact.html?vue&type=template&id=40e331c6&scoped=true&ts=true&external"
import script from "./assign-trustcontact.ts?vue&type=script&lang=ts&external"
export * from "./assign-trustcontact.ts?vue&type=script&lang=ts&external"

import "./assign-trustcontact.scss?vue&type=style&index=0&id=40e331c6&scoped=true&lang=sccs&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e331c6"]])

export default __exports__